module.exports = __webpack_public_path__ + "img/solution-ecusoft-components-pic.617917c5.png";